export const BOT_STATUS = {
  JOINING_CALL: 'JOINING_CALL',
  IN_WAITING_ROOM: 'IN_WAITING_ROOM',
  IN_CALL_NOT_RECORDING: 'IN_CALL_NOT_RECORDING',
  IN_CALL_RECORDING: 'IN_CALL_RECORDING',
  CALL_ENDED: 'CALL_ENDED',
} as const;

export type RawBotStatus = keyof typeof BOT_STATUS;

export const isCallActive = (status: string | null | undefined) =>
  !!status && (status === 'IN_PROGRESS' || status === 'SCHEDULED');
